export default __webpack_public_path__ + "static/media/icon-dark.61d2d0d4.svg";